export default __webpack_public_path__ + "static/media/location.7bb0a2cc.svg";